import React from "react";

interface Column {
  key: string;
  label: string;
  span?: number;
}

interface Props {
  title?: string;
  description?: string; // 👈 Nuevo texto opcional debajo del título
  columns: Column[];
  data: any[];
  emptyMessage?: string;
}

const SimpleDataTable: React.FC<Props> = ({
  title,
  description,
  columns,
  data,
  emptyMessage = "No hay registros disponibles.",
}) => {
  const totalCols = columns.reduce((sum, col) => sum + (col.span ?? 1), 0);

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      {(title || description) && (
        <div className="py-6 px-4 md:px-6 xl:px-7.5">
          {title && (
            <h4 className="text-xl font-semibold text-black dark:text-white">
              {title}
            </h4>
          )}

          {description && (
            <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">
              {description}
            </p>
          )}
        </div>
      )}

      {/* Encabezado */}
      <div
        className={`grid grid-cols-${totalCols} border-t border-stroke py-4.5 px-4 dark:border-strokedark md:px-6 xl:px-7.5`}
      >
        {columns.map((col, index) => (
          <div key={index} className={`col-span-${col.span ?? 1} flex items-center`}>
            <p className="font-medium text-sm text-black dark:text-white">
              {col.label}
            </p>
          </div>
        ))}
      </div>

      {/* Filas */}
      {data.length > 0 ? (
        data.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className={`grid grid-cols-${totalCols} border-t border-stroke py-4.5 px-4 dark:border-strokedark md:px-6 xl:px-7.5`}
          >
            {columns.map((col, colIndex) => (
              <div key={colIndex} className={`col-span-${col.span ?? 1} flex items-center`}>
                <p className="text-sm text-black dark:text-white">
                  {row[col.key] ?? "—"}
                </p>
              </div>
            ))}
          </div>
        ))
      ) : (
        <div className="border-t border-stroke py-6 px-4 text-center text-gray-500 dark:text-gray-400 dark:border-strokedark">
          {emptyMessage}
        </div>
      )}
    </div>
  );
};

export default SimpleDataTable;
